export default "__VITE_ASSET__DHoQ7$ek__"